module.exports = __webpack_public_path__ + "static/media/buy_req_teach_2.08e9a418.jpg";